const deleteSlide = (slideId) => {
  const target = document.querySelector(`#page-thumb-container-with-index-${slideId}`);
  if (!target) return;

  target.dataset.isDeleted = true;
  window.hideContextMenus();
};

export default deleteSlide;
